function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(1 1)"
}, React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.972
}), React.createElement("path", {
  d: "M10.9138889,8.48888889 C13.7468493,11.4245232 18.1011649,12.3000321 21.8486111,10.6875"
}), React.createElement("circle", {
  cx: 16,
  cy: 11.486,
  r: 5.903
}), React.createElement("path", {
  d: "M24.7736111,25.0277778 C23.1690569,21.6354596 19.7526547,19.4721086 16,19.4721086 C12.2473453,19.4721086 8.83094314,21.6354596 7.22638889,25.0277778"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/user.b1adc870.svg";
export { SvgComponent as ReactComponent };